import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Country } from '@tiendanube/common/src/enums';
import { useAppDispatch } from 'App/store';
import { useGetCountry } from 'domains/Auth/hooks';
import { useKycStatus } from 'domains/NuvemPagoCommons/hooks/useKycStatus';
import { getOrdersChargeback, fetchOrdersChargebacks } from '../../ordersSlice';

const countriesEnabledForChargeback = [Country.AR, Country.MX];

function useOrdersChargeback() {
  const { isKycRejected } = useKycStatus();
  const country = useGetCountry();
  const dispatch = useAppDispatch();
  const chargebackFetchedRef = useRef(false);

  const isChargebackAvailable = useMemo(
    () => countriesEnabledForChargeback.includes(country) && !isKycRejected,
    [country, isKycRejected],
  );

  const getChargebacks = useCallback(
    () => dispatch(fetchOrdersChargebacks()),
    [dispatch],
  );
  const chargebacksList = useSelector(getOrdersChargeback);

  useEffect(() => {
    if (!isChargebackAvailable || chargebackFetchedRef.current) {
      return;
    }
    getChargebacks();
    chargebackFetchedRef.current = true;
  }, [getChargebacks, isChargebackAvailable]);

  return {
    chargebacks: chargebacksList,
    getChargebacks,
    isChargebackAvailable,
  };
}

export default useOrdersChargeback;
